// Module
var code = `<!-- blList — blog bullet list.
     Data shape: { items: [ "list item (inline HTML)", ... ] } -->
<ul>
  {{#items}}<li>{{.}}</li>{{/items}}
</ul>
`;
// Exports
module.exports = code;